module.exports = "ahoy tile\n"